import * as shared from '~/shared';
import styled from 'styled-components';
import AlertBox from '~/shared/AlertBox';

export const StyledAlertBox = styled(AlertBox)`
    margin-top: 20px;
`;

export const Button = styled(shared.Button)`
    margin-top: 20px
`;

export const Container = shared.Container;
export const CenterScreenContainer = shared.CenterScreenContainer;
export const Header = shared.Header;
export const SubHeader = shared.SubHeader;
export const StyledLink = shared.StyledLink;
